import { useEffect } from "react";

import { AppConfig } from "../app-config";

const removeDomState = (): void => {
  document.body.classList.remove(
    "dark-mode",
    "light-mode",
    "custom-background",
    "read-only",
    "edit-mode",
    "disable-heading-expand-button",
    "no-padding",
    "fix-ios-sticky-header"
  );
  document.documentElement.classList.remove("fix-ios-sticky-header");
  document.body.style.removeProperty("--dark-mode-custom-background-color");
  document.body.style.removeProperty("--light-mode-custom-background-color");
};

export function useAppDomState(config: AppConfig, enabled = true): void {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const activeCustomBackground = config.isDarkTheme
      ? config.darkModeCustomBackgroundColor
      : config.lightModeCustomBackgroundColor;
    const shouldFixIOSStickyHeader = config.platform === "ios" && config.editable;

    document.body.classList.toggle("dark-mode", config.isDarkTheme);
    document.body.classList.toggle("light-mode", !config.isDarkTheme);
    document.body.classList.toggle("custom-background", !!activeCustomBackground);
    document.body.classList.toggle("read-only", !config.editable);
    document.body.classList.toggle("edit-mode", config.editable);
    document.body.classList.toggle(
      "disable-heading-expand-button",
      config.disableHeadingExpandButton
    );
    document.body.classList.toggle("no-padding", config.ignoreHorizontalPadding);
    document.body.classList.toggle("fix-ios-sticky-header", shouldFixIOSStickyHeader);
    document.documentElement.classList.toggle("fix-ios-sticky-header", shouldFixIOSStickyHeader);

    if (config.darkModeCustomBackgroundColor) {
      document.body.style.setProperty(
        "--dark-mode-custom-background-color",
        config.darkModeCustomBackgroundColor
      );
    } else {
      document.body.style.removeProperty("--dark-mode-custom-background-color");
    }

    if (config.lightModeCustomBackgroundColor) {
      document.body.style.setProperty(
        "--light-mode-custom-background-color",
        config.lightModeCustomBackgroundColor
      );
    } else {
      document.body.style.removeProperty("--light-mode-custom-background-color");
    }

    return () => {
      removeDomState();
    };
  }, [
    config.darkModeCustomBackgroundColor,
    config.disableHeadingExpandButton,
    config.editable,
    config.ignoreHorizontalPadding,
    config.isDarkTheme,
    config.lightModeCustomBackgroundColor,
    config.platform,
    enabled,
  ]);
}
